import React from 'react';
import DraggableList from './DraggableList';
import DraggableListNew from './DraggableListNew';

const UnderScenarioVisual = () => {
    return (
        <>
            <DraggableList />
        </>
    );
};

export default UnderScenarioVisual;

